import gql from 'graphql-tag';

const Query = {
  findCandidateById: gql`
    query candidate($id: Int!) {
      candidate(id: $id) {
        id
        contactId
        userId
        email
        name
        firstname
        phone
        address
        zipcode
        city
        createdAt
        updatedAt

        company {
          code
          name
        }
        signatures {
          id
          label
          uuid
          signUuid
          signDate
          status
          sepaDetailId
          createdAt
          updatedAt
        }
        documents {
          id
          type
          filename
          mimetype
          encoding
          public_url
          category
          createdAt
          updatedAt
        }

        avatar
        hasTremplin
      }
    }
  `,
  findCandidates: gql`
    query candidates($filters: CandidateIndexFilter, $pagination: PageInfoInput, $orderBy: CandidateOrderByInput) {
      candidates(filters: $filters, pagination: $pagination, orderBy: $orderBy) {
        nbHits
        hits {
          id
          contactId
          userId
          email
          name
          firstname
          phone
          address
          zipcode
          city
          createdAt
          updatedAt

          company {
            code
            name
          }
          signatures {
            id
            label
            uuid
            signUuid
            signDate
            status
            sepaDetailId
            createdAt
            updatedAt
          }

          avatar
          hasTremplin
        }
      }
    }
  `,
  transactionInfo: gql`
    query transactionInfo($signUuid: String!) {
      transactionInfo(signUuid: $signUuid) {
        status
        signerInfos {
          status
          actionDate
        }
      }
    }
  `,
  getMeCandidate: gql`
    query meCandidate {
      meCandidate {
        id
        contactId
        userId
        email
        name
        firstname
        phone
        birth_date
        birth_name
        birth_place
        birth_country
        nationality
        address
        zipcode
        city
        father_name
        father_firstname
        mother_name
        mother_firstname
        company {
          code
        }
      }
    }
  `,
  getCandidateMagicLink: gql`
    query candidateMagicLink($id: Int!) {
      candidateMagicLink(id: $id)
    }
  `,
};

const Mutation = {
  retryUniversignCallback: gql`
    mutation retryUniversignCallback($signUuid: String!) {
      retryUniversignCallback(signUuid: $signUuid)
    }
  `,
  updateSignature: gql`
    mutation updateSignature($signatureId: Int!, $params: Signatureinput) {
      updateSignature(signatureId: $signatureId, params: $params)
    }
  `,
  sepaDetailCreateMutation: gql`
    mutation ($params: sepaDetailCreateInput) {
      sepaDetailCreate(params: $params)
    }
  `,
  requestSepaSignatureMutation: gql`
    mutation ($params: requestSepaSignatureInput) {
      requestSepaSignature(params: $params) {
        id
        url
      }
    }
  `,
  signContracts: gql`
    mutation ($params: SignContractsInput!) {
      signContracts(params: $params) {
        url
      }
    }
  `,
};

export default {
  Query,
  Mutation,
};
